import { render, staticRenderFns } from "./InfoClass.vue?vue&type=template&id=3d5d104f&"
import script from "./InfoClass.vue?vue&type=script&lang=js&"
export * from "./InfoClass.vue?vue&type=script&lang=js&"
import style0 from "./InfoClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports